const React = require("react");

const useId = require('@reach/auto-id').useId;

function UserOutlinedIcon(props, svgRef) {
  const id = "UserOutlinedIcon" + '_' + useId();
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.938 13.541a7.438 7.438 0 017.437 7.438.5.5 0 01-1 0 6.438 6.438 0 00-12.875 0 .5.5 0 01-1 0 7.437 7.437 0 017.438-7.438zm0-11.041a4.557 4.557 0 110 9.115 4.557 4.557 0 110-9.115zm0 1a3.557 3.557 0 10-.003 7.114 3.557 3.557 0 00.003-7.114z",
    id: `${id}_a`
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: `#${id}_a`
  }));
}

const ForwardRef = React.forwardRef(UserOutlinedIcon);
const MemoForwardRef = React.memo(ForwardRef);
module.exports = MemoForwardRef;